import { createBreakpoints } from "@chakra-ui/theme-tools";
import { extendTheme } from "@chakra-ui/react";

const breakpoints = createBreakpoints({
  base: "320px",
  md: "768px",
  lg: "960px",
  xl: "1200px",
});

const heading = "IBM PLEX SANS";
const body = "IBM PLEX SANS";

const theme = extendTheme({
  styles: {
    global: {
      "*": {
        "-webkit-font-smoothing": "antialiased",
        " -moz-osx-font-smoothing": "grayscale",
        "font-smoothing": "antialiased",
        "text-rendering": "optimizeLegibility",
      },
      p: {
        whiteSpace: "pre-wrap",
      },
      a: {
        textDecoration: "none",
        color: "#522FFF",
        fontWeight: "600",
        "&:hover": {
          textDecoration: "underline",
        },
      },
      sup: {
        a: {
          textDecoration: "none",
        },
      },
    },
  },
  fonts: {
    body,
    heading,
    mono: "Menlo, monospace",
  },
  breakpoints,
  colors: {
    medgray: {
      500: "#383838",
      600: "#494949",
    },
    brand: {
      500: "#0045e6",
      600: "#0552FF",
    },
    primary: {
      blue: {
        light: "#45CBFE",
        dark: "#121847",
      },
    },
  },
  sizes: {
    "8xl": "1420px",
  },
  components: {
    Container: {
      baseStyle: {
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
      },
    },
    Link: {
      baseStyle: {
        color: "#522FFF",
      },
    },
    Text: {
      variants: {
        body: {
          fontSize: "19px",
          lineHeight: "26px",
          fontWeight: "400",
          fontFamily: "IBM PLEX SANS",
          color: "primary.blue.dark",
        },
        bodySmall: {
          fontSize: "15px",
          fontWeight: "300",
          fontFamily: "IBM PLEX SANS",
          lineHeight: "22px",
          //color: "primary.blue.dark",
        },
        bodyMd: {
          fontSize: "24px",
          lineHeight: "34px",
          fontWeight: "400",
          fontFamily: "IBM PLEX SANS",
          color: "primary.blue.dark",
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: "700",
      },
      variants: {
        heading1: {
          fontSize: "72px",
          lineHeight: "89px",
          fontFamily: "IBM PLEX SANS",
        },
        heading2: {
          fontFamily: "IBM PLEX SANS",
          fontSize: "34px",
          lineHeight: "46px",
          fontWeight: "700",
          color: "primary.blue.dark",
        },
        heading3: {
          fontFamily: "IBM PLEX SANS",
          fontSize: "24px",
          lineHeight: "27px",
          fontWeight: "600",
          color: "primary.blue.dark",
        },
        heading4: {
          fontFamily: "IBM PLEX SANS",
          fontWeight: 700,
          fontSize: "21px",
          lineHeight: "26px",
        },
      },
    },
    Checkbox: {
      baseStyle: {
        control: {
          bg: "white",
          _checked: {
            bg: "white",
            // h: "40px",
            // w: "40px",
          },
          _active: {
            bg: "white",
          },
        },
      },
      sizes: {
        lg: {
          px: 10,
          py: 10,
        },
      },
    },
    // FormLabel: {
    //   baseStyle: {
    //     fontWeight: "600",
    //   },
    // },
    Button: {
      baseStyle: {
        fontFamily: "IBM PLEX SANS",
        py: "8px",
        px: "16px",
        lineHeight: "1",
      },
      variants: {
        outline: ({ color }) => ({
          borderRadius: 0,
          borderWidth: 1,
          borderColor: color,
          px: 6,
          fontWeight: 300,
        }),
        primary: {
          textDecoration: "none",
          textTransform: "uppercase",
          display: "inline-flex",
          color: "#fff",
          fontWeight: "400",
          fontSize: "12px",
          letterSpacing: "0.1em",
          p: "16px 24px",
          bg: "#674DE8",
          _hover: {
            background: "#523eba",
            textDecoration: "none",
          },
          _active: {
            background: "#523eba",
          },
        },
        secondary: {
          textDecoration: "none",
          textTransform: "uppercase",
          display: "inline-flex",
          color: "#000",
          fontWeight: "400",
          fontSize: "12px",
          letterSpacing: "0.1em",
          p: "24px 20px",
          bg: "#45CBFE",
          _hover: {
            background: "#3eb7e5",
            textDecoration: "none",
          },
          _active: {
            background: "#3eb7e5",
          },
        },
        alternate: {
          fontSize: "12px",
          mt: "20px",
          textDecor: "none",
          display: "inline-flex",
          color: "#fff",
          fontWeight: "400",
          letterSpacing: "0.1em",
          padding: "24px",
          bg: "#522fff",
          _hover: {
            background: "#4a2ae6",
          },
          _active: {
            background: "#4a2ae6",
          },
        },
        primaryLarge: {
          background: "#765FE8",
          color: "white",
          fontWeight: 300,
          fontSize: "23px",
          padding: "16px 10px",
          border: "1px solid #121847",
          height: "auto",
        },
        secondaryLarge: {
          background: "#FFFFFF",
          color: "#121847",
          fontWeight: 300,
          fontSize: "23px",
          padding: "16px 10px",
          border: "1px solid #121847",
          height: "auto",
          "&:hover": {
            background: "#765FE8",
            color: "white",
          },
        },
      },
    },
  },
});

export default theme;
